import React from 'react';
import './index.module.less';
import { SettingItemInfo } from '../SettingItem/index.d';
import SettingItem from '../SettingItem';

interface IProp {
  infoList: SettingItemInfo[];
}

const SettingItemCard = (props: IProp) => {
  const { infoList } = props;
  if (!infoList || infoList.length === 0) {
    return;
  }
  const itemElements = infoList.map((info: SettingItemInfo, index: number) => {
    return <SettingItem key={info.title} info={info}/>;
  });
  return <div styleName='container'>{itemElements}</div>;
}

export default SettingItemCard;